import { jsx as a, jsxs as p } from "react/jsx-runtime";
import { forwardRef as g } from "react";
const m = {
  accent: "var(--accent-default)",
  success: "var(--success)",
  warning: "var(--warning)",
  error: "var(--error)",
  neutral: "var(--text-primary)"
};
function b({
  value: r,
  label: e,
  sublabel: o,
  tone: t = "neutral",
  align: n = "start",
  children: l
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-private-stat": !0,
      "data-tone": t,
      "data-align": n,
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: n === "center" ? "center" : "flex-start",
        gap: "var(--space-1)",
        textAlign: n === "center" ? "center" : "start",
        minWidth: 0
      },
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            style: {
              color: m[t],
              fontFamily: "var(--font-sans)",
              fontSize: "var(--text-2xl)",
              fontWeight: 700,
              letterSpacing: "var(--tracking-tight)",
              lineHeight: "var(--line-2xl)"
            },
            children: r
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            style: {
              color: "var(--text-secondary)",
              fontSize: "var(--text-sm)",
              fontWeight: 500,
              lineHeight: "var(--line-sm)"
            },
            children: e
          }
        ),
        o ? /* @__PURE__ */ a(
          "div",
          {
            style: {
              color: "var(--text-tertiary)",
              fontSize: "var(--text-xs)",
              fontWeight: 500,
              lineHeight: "var(--line-xs)"
            },
            children: o
          }
        ) : null,
        l
      ]
    }
  );
}
const x = {
  xs: "var(--space-1)",
  sm: "var(--space-1_5)",
  md: "var(--space-2_5)"
}, y = {
  accent: "var(--accent-default)",
  success: "var(--success)",
  warning: "var(--warning)",
  error: "var(--error)",
  neutral: "var(--neutral)"
};
function w({
  value: r,
  max: e = 100,
  size: o = "sm",
  tone: t = "accent",
  "aria-label": n,
  "aria-labelledby": l
}) {
  const s = e <= 0 ? 100 : e, c = Math.max(0, Math.min(s, r)), i = c / s * 100;
  return /* @__PURE__ */ a(
    "div",
    {
      role: "progressbar",
      "aria-valuenow": c,
      "aria-valuemin": 0,
      "aria-valuemax": s,
      "aria-label": n,
      "aria-labelledby": l,
      "data-private-progressbar": !0,
      "data-tone": t,
      "data-size": o,
      style: {
        width: "100%",
        height: x[o],
        background: "var(--bg-elevated)",
        borderRadius: "var(--radius-pill)",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ a(
        "div",
        {
          style: {
            width: `${i}%`,
            height: "100%",
            background: y[t],
            borderRadius: "var(--radius-pill)",
            transition: "width var(--duration-slower) var(--ease-out)"
          }
        }
      )
    }
  );
}
const S = "Conversion funnel";
function _(r, e) {
  return typeof r.pct == "number" ? r.pct : e.value <= 0 ? 0 : r.value / e.value * 100;
}
function R(r) {
  if (!Number.isFinite(r)) return "0%";
  const e = Math.round(r * 10) / 10;
  return Number.isInteger(e) ? `${e}%` : `${e.toFixed(1)}%`;
}
const A = g(function({ steps: e, showConnectors: o = !0, "aria-label": t = S, className: n, id: l }, s) {
  if (e.length === 0)
    return /* @__PURE__ */ a(
      "section",
      {
        ref: s,
        id: l,
        "aria-label": t,
        "data-funnel-empty": !0,
        className: ["ls-funnel", n].filter(Boolean).join(" ")
      }
    );
  const c = e[0];
  return c ? /* @__PURE__ */ a(
    "section",
    {
      ref: s,
      id: l,
      "aria-label": t,
      "data-funnel": !0,
      "data-step-count": e.length,
      className: ["ls-funnel", n].filter(Boolean).join(" "),
      style: {
        display: "grid",
        gridTemplateColumns: `repeat(${e.length}, minmax(0, 1fr))`,
        columnGap: "var(--space-3)",
        rowGap: "var(--space-2)",
        alignItems: "stretch",
        width: "100%"
      },
      children: e.map((i, d) => {
        const u = _(i, c), v = i.tone ?? "accent", h = d === e.length - 1, f = `${l ?? "ls-funnel"}-${i.id}-label`;
        return /* @__PURE__ */ p(
          "div",
          {
            "data-funnel-step": !0,
            "data-step-id": i.id,
            "data-step-index": d,
            style: {
              position: "relative",
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-2)",
              minWidth: 0
            },
            children: [
              /* @__PURE__ */ a(
                b,
                {
                  value: i.value.toLocaleString(),
                  label: /* @__PURE__ */ a("span", { id: f, children: i.label }),
                  sublabel: R(u),
                  tone: v,
                  align: "start"
                }
              ),
              /* @__PURE__ */ a(w, { value: u, tone: v, size: "sm", "aria-labelledby": f }),
              o && !h ? /* @__PURE__ */ a(
                "span",
                {
                  "aria-hidden": !0,
                  "data-funnel-connector": !0,
                  style: {
                    position: "absolute",
                    top: "var(--space-2)",
                    right: "calc(var(--space-3) * -0.5 - var(--space-1))",
                    width: "var(--space-2)",
                    height: "var(--space-2)",
                    borderTop: "1.5px solid var(--border-default)",
                    borderRight: "1.5px solid var(--border-default)",
                    transform: "rotate(45deg)",
                    transformOrigin: "center",
                    pointerEvents: "none"
                  }
                }
              ) : null
            ]
          },
          i.id
        );
      })
    }
  ) : /* @__PURE__ */ a(
    "section",
    {
      ref: s,
      id: l,
      "aria-label": t,
      "data-funnel-empty": !0,
      className: ["ls-funnel", n].filter(Boolean).join(" ")
    }
  );
});
export {
  A as F
};
//# sourceMappingURL=Funnel-CrCFL20E.js.map
